import Icon from '../components/Icon.vue'

Icon.register({
  crop: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 352H448V109.3L507.3 49.9C513.6 43.7 513.6 33.6 507.3 27.3L484.7 4.7C478.4-1.6 468.3-1.6 462.1 4.7L402.8 64H192V160H306.8L160 306.8V24C160 10.7 149.3 0 136 0H88C74.8 0 64 10.7 64 24V64H24C10.8 64 0 74.7 0 88V136C0 149.3 10.8 160 24 160H64V424C64 437.3 74.8 448 88 448H320V352H205.3L352 205.3V488C352 501.3 362.8 512 376 512H424C437.3 512 448 501.3 448 488V448H488C501.3 448 512 437.3 512 424V376C512 362.7 501.3 352 488 352z'
      }
    ]
  }
})
